import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDsoRegionList } from '../../../../../actions/dsosActions';
import { Combobox } from '../../../../commonComponents/Combobox/Combobox';

export const RegionFilter = ({ dsoId, filters, onChange }) => {
  const dispatch = useDispatch();

  const {
    data,
    filters: regionOptionsFilters,
    total,
  } = useSelector((state) => state.dsos.dsoRegionList);

  const options = useMemo(
    () =>
      data.map((it) => ({
        label: it.name,
        value: it.id,
      })),
    [data],
  );

  useEffect(() => {
    if (dsoId) {
      dispatch(fetchDsoRegionList(dsoId, { page: 1 }, true));
    }
  }, [dispatch, dsoId]);

  return (
    <Combobox
      isDisabled={!dsoId}
      hasReachMax={total === data.length}
      isAutoApply
      isPaged
      label="Region:"
      options={options}
      placeholder="All"
      values={options?.find((it) => it.value === filters.regionId) || []}
      onChange={(values) => {
        onChange('regionId', values?.value);
      }}
      onNextPage={() => {
        dispatch(fetchDsoRegionList(dsoId, { page: regionOptionsFilters.page + 1 }));
      }}
    />
  );
};
